export default __webpack_public_path__ + "static/media/payment-failure-light.e38c6e61.png";